"use strict";

import { knowledgeConstants } from "../_constants";

export const knowledgeLatestQuizzesRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_LATEST_QUIZZES_REQUEST,
        payload,
    };
};

export const knowledgeLatestQuizzesComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_LATEST_QUIZZES_COMPLETE,
        payload,
    };
};

export const knowledgeDashboardRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_DASHBOARD_REQUEST,
        payload,
    };
};

export const knowledgeDashboardComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_DASHBOARD_COMPLETE,
        payload,
    };
};

export const participantQuizzesRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_PARTICIPANT_QUIZZES_REQUEST,
        payload,
    };
};

export const participantQuizzesComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_PARTICIPANT_QUIZZES_COMPLETE,
        payload,
    };
};

export const quizzDetailsRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_QUIZZE_DETAILS_REQUEST,
        payload,
    };
};

export const quizzDetailsComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_QUIZZE_DETAILS_COMPLETE,
        payload,
    };
};

export const answerQuestionRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_ANSWER_QUESTION_REQUEST,
        payload,
    };
};

export const anwerQuestionComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_ANSWER_QUESTION_COMPLETE,
        payload,
    };
};

export const enrolQuizzRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_REQUEST,
        payload,
    };
};

export const enrolQuizzComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_ENROL_QUIZZE_COMPLETE,
        payload,
    };
};

export const questionResultRequest = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_QUESTION_RESULT_REQUEST,
        payload,
    };
};

export const questionResultComplete = (payload) => {
    return {
        type: knowledgeConstants.KNOWLEDGE_QUESTION_RESULT_COMPLETE,
        payload,
    };
};
